import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { APP_CONFIG, IAppConfig } from '@app/core/config';
import { UtilsService } from '@app/core/services';
import { CurrencyList, DepartmentList } from '../models';


@Injectable({
	providedIn: 'root'
})
export class DepartmentService {

	constructor(
		@Inject(APP_CONFIG) private appConfig: IAppConfig,
		private httpClient: HttpClient,
		private utilsService: UtilsService
	) { }


	getList(): Observable<DepartmentList[]> {
		return this.httpClient
			.get<CurrencyList[]>(`${this.appConfig.apiEndpoint}/v2/common/departments`)
			.pipe(map(this.utilsService.handleResponse));
	}
}
